import React from "react";
import { Container } from "react-bootstrap";

const SocialContainer = ({ path }) => {
  const basePath = "https://www.vivaholidays.com.au";

  return (
    <Container className="social-share mb-4">
      <div className="social-share-options">
        <ul className="nav justify-content-end">
          <li className="nav-item">
            <a
              className="nav-link"
              href={`https://twitter.com/intent/tweet?url=${basePath}${path}`}
              target="_blank"
            >
              <i className="fab fa-twitter"></i>
            </a>
          </li>
          <li className="nav-item">
            <a
              className="nav-link"
              href={`https://www.facebook.com/sharer/sharer.php?u=${basePath}${path}`}
              target="_blank"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
          </li>
        </ul>
      </div>
    </Container>
  );
};

export default SocialContainer;
